import axios from "axios";
import { escapeQuotes } from "../components/global/GlobalTools";

const axiosOptions = {
  url: process.env.REACT_APP_GRAPHQL_URL,
  method: "post",
};

export const createAddress = async (values) => {
  axiosOptions.headers = {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  };
  axiosOptions.data = {
    query: `
      mutation {
        createAddress(
          input: {
            data: {
              Street: "${escapeQuotes(values.street)}"
              Street2: "${escapeQuotes(values.second_street)}"
              City: "${escapeQuotes(values.city)}"
              State: "${escapeQuotes(values.state)}"
              Zip: "${escapeQuotes(values.zip)}"
              Country: "${escapeQuotes(values.country)}"
            }
          }
        ) {
          address {
            id
          }
        }
      }
    `,
  };
  try {
    const response = await axios(axiosOptions);
    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

/**
 *  update an existing address
 * @param {int} id
 * @param {*} values
 * @returns
 */
export const updateAddress = async (id, values) => {
  axiosOptions.headers = {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  };
  axiosOptions.data = {
    query: `
      mutation {
        updateAddress(
          input: {
            where:{id:${id}}
            data: {
              Street: "${escapeQuotes(values.street)}"
              Street2: "${escapeQuotes(values.second_street)}"
              City: "${escapeQuotes(values.city)}"
              State: "${escapeQuotes(values.state)}"
              Zip: "${escapeQuotes(values.zip)}"
              Country: "${escapeQuotes(values.country)}"
            }
          }
        ) {
          address {
            id
          }
        }
      }
    `,
  };
  try {
    const response = await axios(axiosOptions);
    return response.data;
  } catch (error) {
    console.log(error);
    return error;
  }
};

/**
 * delete an address
 * @param {*} id
 * @returns
 */
export const deleteAddress = async (id) => {
  axiosOptions.headers = {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  };
  axiosOptions.data = {
    query: `
        mutation{
          deleteAddress(
            input:{
              where:{id:${id}},
            }
          )
          {
            address{
              id
            }
          }
        }
      `,
  };
  try {
    const response = await axios(axiosOptions);
    return response.data;
  } catch (error) {
    return error;
  }
};
